module.exports = __webpack_public_path__ + "img/vmc_aniv7_24Aug2021.60271f8e.jpg";